import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

const bull = (
  <Box
    component="span"
    sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
  >
    •
  </Box>
);

export default function GraficCard({
  value = false,
  icon,
  title,
  date,
  coldValue = false,
  heatValue = false,
}) {
  return (
    <Card sx={{ width: 150 }}>
      <CardContent>
        <Typography align="center" variant="subtitle2" component="div">
          {date}
        </Typography>
        {value && (
          <Typography align="center" variant="subtitle2" gutterBottom>
            {value}
          </Typography>
        )}
        {heatValue && (
          <Typography align="center" variant="subtitle2" gutterBottom>
            {heatValue}
          </Typography>
        )}
        {coldValue && (
          <Typography align="center" variant="subtitle2" gutterBottom>
            {coldValue}
          </Typography>
        )}
        <Typography variant="h5" component="div" align="center" sx={{ mt: 2 }}>
          {icon}
        </Typography>
      </CardContent>
      {/*  <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
  );
}
